import styled from "@emotion/styled";
import { MOBILE_QUERY_MAX_WIDTH, TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledDirectoryHeaderComponent = styled.div`
  .directory-header-component {
    .image-container {
      position: absolute;
      left: 0;
      top: -65px;

      width: 30vw;

      img {
        width: 100%;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .directory-header-component {
      height: 30vh;

      img {
        display: none;
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .directory-header-component {
      height: 60vh;
      min-height: 460px;
    }
  }
`;
